import { ControlInterface } from 'edocatbase/Form';

import { default as MuiDatePicker } from "../../../DatePicker";

import { getTimeFormat, getBooleanValue } from '../../lib/date';

interface DatePickerProps extends ControlInterface {
	readOnly: boolean;
	helperText: string;
	important: boolean;
	docgenform?: boolean | undefined;
}

export default class DatePicker extends window.React.PureComponent<DatePickerProps> {
	onFieldChange = (value: any) => {
		const { onChange, name, dirty } = this.props;
		onChange([name], value, dirty);
	};

	onBlur = () => {
		const { onBlur, name, value, dirty } = this.props;
		// @ts-ignore
		onBlur(name, value, dirty);
	};

	render() {
		const {
			label,
			disabled,
			value,
			dataType,
			control: {
				params: { showTime, minDate, dateFormat, timeFormat },
			},
			mandatory,
			name,
			className,
			placeholder,
			error,
			readOnly,
			helperText,
			important,
			docgenform,
			onChange,
			dirty
		} = this.props;
		
		let finalValue = value;
		if(docgenform && ['now', 'todayPlus'].includes(value?._i)){
			onChange([name], {
				label: value?._i,
				value: value?._i
			}, dirty);
			finalValue = {
				label: value?._i,
				value: value?._i
			};
		} else {
			if (value?._i === 'now') {
				finalValue = window.moment();
				this.onFieldChange(finalValue);
			} else if (value?._i?.startsWith('todayPlus')) {
				const days = value._i.match(/\d+/);
				if (days?.[0] && !isNaN(days[0])){
					finalValue = window.moment().add(days[0], 'days');
				}
				this.onFieldChange(finalValue);
			}
		}

		return readOnly || disabled ? (
			<div className={`form-row row-${name} ${readOnly ? 'simple-row' : 'read-only-row'}`}>
				<label>{label}</label>
				<div id={name}>
					{finalValue
						? window
								.moment(finalValue)
								.format(window.Edocat.Config[dataType === 'date' ? 'dateFormat' : 'dateTimeFormat'])
						: window.Alfresco.messages.global['label.none']}
				</div>
			</div>
		) : (
			<div className={`form-row row-${name}`}>
				<MuiDatePicker
					className={className}
					dataType={dataType}
					dateFormat={dateFormat}
					disabled={(docgenform && ['now', 'todayPlus'].includes(finalValue?.value)) || (!readOnly && disabled)}
					isClearable={!mandatory && !disabled}
					label={label}
					mandatory={!readOnly && mandatory}
					minDate={minDate}
					name={name}
					onBlur={this.onBlur}
					onChange={this.onFieldChange}
					selected={(docgenform && ['now', 'todayPlus'].includes(finalValue?.value)) ? "" :finalValue}
					showTimeSelect={getBooleanValue(showTime)}
					timeFormat={getTimeFormat(showTime, timeFormat)}
					placeholder={(docgenform && ['now', 'todayPlus'].includes(finalValue?.value)) ? finalValue?.label : placeholder}
					error={error}
					readOnly={readOnly}
					helperText={helperText}
					important={important}
					id={name}
				/>
			</div>
		);
	}
}
